import { n as e } from "../constants-Ba4J7LQm.js";
//#region src/api/createDemoAccountsApi.ts
var t = Object.keys(e), n = class extends Error {
	kind;
	constructor(e, t) {
		super(e), this.kind = t;
	}
};
function r(e) {
	let { http: r, tradingApiBaseUrl: i } = e, a = null;
	return {
		list: () => (a || (a = (async () => e.logins.length === 0 ? [] : (await r.get("/api/v1/trading/accounts", {
			baseURL: i,
			params: { trading_account_ids: e.logins.join(",") }
		})).data.filter((e) => e.account_type === "demo").filter((e) => t.includes(e.currency)).map((e) => ({
			login: e.login,
			accountType: "demo",
			currency: e.currency,
			balance: e.balance
		})))(), a.catch(() => {
			a = null;
		})), a),
		reset: async (e, t, a = "Demo balance reset") => {
			try {
				return { newBalance: (await r.post(`/api/v1/trading/accounts/${e}/balance/reset-demo`, {
					amount: t,
					comment: a
				}, { baseURL: i })).data.new_balance };
			} catch (e) {
				let t = e, r = t.response?.status, i = t.response?.data?.context?.mt5_code_name;
				throw new n(t.response?.data?.detail ?? "Reset failed", r === 409 && i === "TOO_FREQUENT" ? "too-frequent" : r === 409 && i === "REJECTED" ? "rejected" : "generic");
			}
		}
	};
}
//#endregion
export { r as createDemoAccountsApi };
